(function () {
  var packages = [
    { name: 'Business Essential — Starter 20', panels: 42, modules: 5, clusters: 1, inverter: 20 },
    { name: 'Business Essential — Growth 40', panels: 84, modules: 8, clusters: 1, inverter: 40 },
    { name: 'Business Performance — 60 kW', panels: 126, modules: 18, clusters: 2, inverter: 60 },
    { name: 'Business Performance — 80 kW', panels: 168, modules: 30, clusters: 2, inverter: 80 },
    { name: 'Business Enterprise — 100 kW', panels: 210, modules: 39, clusters: 3, inverter: 100 }
  ];

  var labels = {
    business: {
      'retail-office': 'Retail / office', hospitality: 'Hospitality / food', warehouse: 'Warehouse / logistics',
      workshop: 'Workshop / manufacturing', refrigeration: 'Cold storage / refrigeration', other: 'Other business'
    },
    tenure: { owner: 'Site owned', 'long-lease': 'Long-term lease', approval: 'Landlord approval needed', unsure: 'Site control not sure' },
    connection: { 'single-nmi': 'Single NMI / meter', 'multiple-nmi': 'Multiple NMIs / meters', embedded: 'Embedded network', unsure: 'Not sure' },
    spend: { 'under-2000': 'Under $2,000', '2000-5000': '$2,000–$5,000', '5000-10000': '$5,000–$10,000', 'over-10000': 'Over $10,000', unsure: 'Not sure' },
    demand: { yes: 'Yes', no: 'No', unsure: 'Not sure' },
    hours: { daytime: 'Mainly daytime', 'day-evening': 'Day and evening', always: '24 / 7', variable: 'Seasonal / variable' },
    existingSolar: { none: 'No existing solar', 'under-30': 'Under 30 kW', '30-60': '30–60 kW', '60-100': '60–100 kW', 'over-100': 'Over 100 kW', unsure: 'Not sure' },
    supply: { three: 'Three phase', 'high-voltage': 'High voltage', single: 'Single phase', unsure: 'Not sure' },
    loads: { refrigeration: 'Refrigeration', hvac: 'HVAC', machinery: 'Machinery / compressors', cooking: 'Ovens / commercial cooking', pumps: 'Pumps / motors', fleet: 'EV / fleet charging', it: 'IT / server equipment', other: 'Other major load' },
    goal: { bills: 'Reduce energy bills', demand: 'Reduce peak demand', backup: 'Business continuity', fleet: 'Support EV fleet', emissions: 'Lower emissions', compare: 'Compare all benefits' },
    backup: { none: 'No backup required', essential: 'Essential systems', operations: 'Selected operations', 'whole-site': 'Whole-site assessment', unsure: 'Not sure' },
    space: { roof: 'Clear roof area', carpark: 'Carpark / canopy', mixed: 'Mixed roof / ground', limited: 'Limited or shaded area', unsure: 'Not sure' },
    future: { fleet: 'More EVs / chargers', expansion: 'Business expansion', electrification: 'Equipment electrification', hvac: 'New HVAC / refrigeration' },
    model: { purchase: 'Purchase', finance: 'Finance', ppa: 'PPA / managed service', compare: 'Compare options' },
    vpp: { benefits: 'Show available benefits', interested: 'Interested', no: 'Not interested', unsure: 'Not sure' },
    timing: { assessment: 'Ready for assessment', 'three-months': 'Within 3 months', 'six-months': '3–6 months', exploring: 'Exploring options' },
    data: { bill: 'Recent bill', interval: 'Interval data', switchboard: 'Switchboard details', plans: 'Roof / site plans' }
  };

  function setPressed(buttons, activeButton) {
    buttons.forEach(function (button) {
      var active = button === activeButton;
      button.classList.toggle('is-active', active);
      if (button.getAttribute('role') === 'radio') {
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      } else {
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });
  }

  function setupRovingGroup(buttons) {
    if (!buttons.length) return;
    var container = buttons[0].parentElement;
    var fieldset = container && container.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('legend');
    container.setAttribute('role', 'radiogroup');
    if (legend) container.setAttribute('aria-label', legend.textContent.trim());
    buttons.forEach(function (button, index) {
      var active = button.classList.contains('is-active') || button.getAttribute('aria-pressed') === 'true';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', active ? 'true' : 'false');
      button.removeAttribute('aria-pressed');
      button.tabIndex = active ? 0 : -1;
      button.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        buttons[nextIndex].click();
        buttons[nextIndex].focus();
      });
    });
  }

  function toggleMulti(button, selected, value) {
    var index = selected.indexOf(value);
    if (index === -1) selected.push(value);
    else selected.splice(index, 1);
    var active = selected.indexOf(value) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function listLabels(values, map) {
    return values.length ? values.map(function (value) { return map[value]; }).join(', ') : 'None selected';
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function initialise(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    var state = {
      business: 'retail-office',
      tenure: 'owner',
      connection: 'single-nmi',
      spend: '2000-5000',
      demand: 'unsure',
      hours: 'daytime',
      type: 'solar-battery',
      existingSolar: 'none',
      supply: 'three',
      loads: [],
      goal: 'bills',
      backup: 'none',
      space: 'roof',
      future: [],
      model: 'purchase',
      vpp: 'benefits',
      timing: 'assessment',
      data: []
    };

    var groups = {
      business: Array.prototype.slice.call(root.querySelectorAll('[data-business]')),
      tenure: Array.prototype.slice.call(root.querySelectorAll('[data-tenure]')),
      connection: Array.prototype.slice.call(root.querySelectorAll('[data-connection]')),
      spend: Array.prototype.slice.call(root.querySelectorAll('[data-spend]')),
      demand: Array.prototype.slice.call(root.querySelectorAll('[data-demand]')),
      hours: Array.prototype.slice.call(root.querySelectorAll('[data-hours]')),
      type: Array.prototype.slice.call(root.querySelectorAll('[data-system-type]')),
      existingSolar: Array.prototype.slice.call(root.querySelectorAll('[data-existing-solar]')),
      supply: Array.prototype.slice.call(root.querySelectorAll('[data-supply]')),
      loads: Array.prototype.slice.call(root.querySelectorAll('[data-load]')),
      goal: Array.prototype.slice.call(root.querySelectorAll('[data-goal]')),
      backup: Array.prototype.slice.call(root.querySelectorAll('[data-backup]')),
      space: Array.prototype.slice.call(root.querySelectorAll('[data-space]')),
      future: Array.prototype.slice.call(root.querySelectorAll('[data-future]')),
      model: Array.prototype.slice.call(root.querySelectorAll('[data-model]')),
      vpp: Array.prototype.slice.call(root.querySelectorAll('[data-vpp]')),
      timing: Array.prototype.slice.call(root.querySelectorAll('[data-timing]')),
      data: Array.prototype.slice.call(root.querySelectorAll('[data-data]'))
    };

    var postcode = root.querySelector('[data-postcode]');
    var leadForm = root.querySelector('.sbs-lead-form');
    var leadBusiness = root.querySelector('[data-lead-business]');
    var leadName = root.querySelector('[data-lead-name]');
    var leadEmail = root.querySelector('[data-lead-email]');
    var leadPhone = root.querySelector('[data-lead-phone]');
    var leadAddress = root.querySelector('[data-lead-address]');
    var leadConsent = root.querySelector('[data-lead-consent]');
    var leadError = root.querySelector('[data-lead-error]');
    var packageBodyField = root.querySelector('[data-package-body]');
    var packageField = root.querySelector('[data-package-field]');
    var answersField = root.querySelector('[data-answers-field]');

    function output(name, value) {
      var element = root.querySelector('[data-' + name + ']');
      if (element) element.textContent = value;
    }

    function packageIndex() {
      var score = { 'under-2000': 0, '2000-5000': 1, '5000-10000': 2, 'over-10000': 4, unsure: 1 }[state.spend];
      score += { 'retail-office': 0, hospitality: .5, warehouse: .25, workshop: .75, refrigeration: 1, other: .25 }[state.business];
      score += { daytime: 0, 'day-evening': .5, always: 1, variable: .25 }[state.hours];
      if (state.demand === 'yes') score += .35;

      var loadScore = 0;
      state.loads.forEach(function (load) {
        loadScore += { refrigeration: .65, hvac: .35, machinery: .65, cooking: .45, pumps: .35, fleet: .65, it: .25, other: .25 }[load];
      });
      score += Math.min(loadScore, 1.5);
      score += { bills: 0, demand: .4, backup: .5, fleet: .5, emissions: 0, compare: .2 }[state.goal];
      score += { none: 0, essential: .35, operations: .75, 'whole-site': 1.25, unsure: .2 }[state.backup];
      score += Math.min(state.future.length * .3, .9);
      return clamp(Math.round(score), 0, 4);
    }

    function render() {
      var selected = packages[packageIndex()];
      var solarKw = selected.panels * .475;
      var batteryKwh = selected.modules * 5.12;
      var postcodeValue = postcode && postcode.value.trim() ? postcode.value.trim() : 'Not supplied';
      var postcodeIsNsw = /^2\d{3}$/.test(postcodeValue);
      var postcodeIsComplete = /^\d{4}$/.test(postcodeValue);
      var isBatteryOnly = state.type === 'battery-only';
      var isSolarOnly = state.type === 'solar-only';
      var isComparison = state.type === 'compare';
      var includesBattery = !isSolarOnly;
      var supplyAssumption = state.supply === 'unsure' ? 'Verification required' : labels.supply[state.supply];
      var supplyBadge = state.supply === 'high-voltage' ? 'HV' : (state.supply === 'single' ? '1Ø REVIEW' : (state.supply === 'unsure' ? 'SUPPLY CHECK' : '3Ø'));
      var clusterWord = selected.clusters === 1 ? 'cluster' : 'clusters';
      var systemLabel = { 'solar-battery': 'Solar + battery', 'solar-only': 'Solar only', 'battery-only': 'Battery only', compare: 'Compare suitable pathways' }[state.type];
      var solarValue = isBatteryOnly ? 'Existing solar' : solarKw.toFixed(2) + ' kW';
      var solarDetail = isBatteryOnly
        ? labels.existingSolar[state.existingSolar] + '; array, inverter and export compatibility assessed before design.'
        : selected.panels + ' × Risen 475 W panels';
      var inverterValue;
      var inverterDetail;

      if (state.supply === 'single' && selected.inverter > 20) {
        inverterValue = selected.inverter + ' kW conversion pathway';
        inverterDetail = 'Solis commercial platform with three-phase supply or approved staged architecture to be assessed.';
      } else if (state.supply === 'single') {
        inverterValue = selected.inverter + ' kW single-phase review';
        inverterDetail = 'Solis pathway subject to supply capacity, export limits and network approval.';
      } else if (state.supply === 'high-voltage') {
        inverterValue = selected.inverter + ' kW HV interface';
        inverterDetail = 'Solis commercial platform with transformer and protection interface confirmed during design.';
      } else if (state.supply === 'unsure') {
        inverterValue = selected.inverter + ' kW supply review';
        inverterDetail = 'Solis commercial design class shown provisionally; supply and network pathway must be verified before equipment selection.';
      } else {
        inverterValue = selected.inverter + ' kW three-phase';
        inverterDetail = 'Solis commercial platform; exact model and architecture confirmed during design.';
      }

      if (isBatteryOnly) inverterDetail += ' Existing solar and inverter integration are included in the assessment.';

      var fitNotes = [];
      if (state.tenure === 'approval') fitNotes.push('landlord approval');
      if (state.connection === 'multiple-nmi') fitNotes.push('multiple-meter allocation');
      if (state.connection === 'embedded') fitNotes.push('embedded-network and stakeholder approvals');
      if (state.connection === 'unsure') fitNotes.push('NMI / metering arrangement');
      if (state.supply === 'single') fitNotes.push('supply / network pathway');
      if (state.supply === 'unsure') fitNotes.push('electricity supply verification');
      if (state.space === 'limited') fitNotes.push('alternative mounting or reduced array fit');
      if (state.space === 'unsure') fitNotes.push('available installation area');
      if (state.existingSolar === 'over-100') fitNotes.push('large-system integration and network settings');
      else if (state.existingSolar !== 'none' && !isBatteryOnly) fitNotes.push('combined existing and new solar capacity');
      var siteFit = fitNotes.length ? 'Assessment needed: ' + fitNotes.join(', ') : 'Good starting fit';

      var nextStep = 'Review a recent bill and request interval data';
      if (state.data.indexOf('interval') !== -1) nextStep = 'Analyse interval data and connection capacity';
      else if (state.tenure === 'approval') nextStep = 'Confirm landlord approval and lease term';
      else if (state.connection !== 'single-nmi') nextStep = 'Confirm metering, NMI and network responsibilities';
      else if (state.supply === 'single') nextStep = 'Confirm supply and network upgrade pathway';
      else if (state.timing === 'three-months') nextStep = 'Book site assessment and data review';

      var loadNote = state.loads.length ? ' Major loads include ' + listLabels(state.loads, labels.loads).toLowerCase() + '.' : '';
      var backupNote = state.backup === 'none' ? '' : ' Backup scope: ' + labels.backup[state.backup].toLowerCase() + '.';
      var futureNote = state.future.length ? ' Future plans include ' + listLabels(state.future, labels.future).toLowerCase() + '.' : '';
      var summary = 'Selected for a ' + labels.business[state.business].toLowerCase() + ' site spending ' + labels.spend[state.spend].toLowerCase() + ' per month, operating ' + labels.hours[state.hours].toLowerCase() + ' and focused on ' + labels.goal[state.goal].toLowerCase() + '. Demand charge: ' + labels.demand[state.demand].toLowerCase() + '.' + loadNote + backupNote + futureNote;

      output('package-name', selected.name + (isBatteryOnly ? ' Storage' : (isSolarOnly ? ' Solar' : (isComparison ? ' Options' : ''))));
      output('package-badge', selected.inverter + ' kW CLASS · ' + supplyBadge);
      output('solar-value', solarValue);
      output('solar-detail', solarDetail);
      output('battery-value', isSolarOnly ? 'Not included' : batteryKwh.toFixed(2) + ' kWh');
      output('battery-detail', isSolarOnly ? 'Storage can be added after interval-data and payback review.' : selected.modules + ' × 5.12 kWh STACK100 Pro modules across ' + selected.clusters + ' ' + clusterWord + ', nominal; usable capacity confirmed during assessment.');
      output('inverter-value', inverterValue);
      output('inverter-detail', inverterDetail);
      output('recommendation-summary', summary);
      output('site-fit', siteFit);
      output('next-step', nextStep);
      output('stc-value', isBatteryOnly ? 'Not applicable to a battery-only package' : (state.existingSolar !== 'none' ? 'Combined existing and new site capacity reviewed before eligible new solar is calculated' : 'Calculated separately for eligible new solar against current rules'));
      output('battery-stc-value', includesBattery ? (batteryKwh > 100 ? 'Not assumed at this package size; current program eligibility checked separately' : 'Eligibility, usable capacity and certificate value confirmed separately') : 'Not applicable to a solar-only package');
      output('prc-value', includesBattery ? (postcodeIsNsw ? 'NSW eligibility and certificate value confirmed separately' : (postcodeIsComplete ? 'NSW PRC not assumed; applicable state programs checked separately' : 'Postcode and current scheme eligibility confirmed separately')) : 'Not applicable to a solar-only package');
      output('vpp-value', includesBattery ? (batteryKwh > 55.55 ? 'Not assumed at this package size; commercial flexibility options reviewed separately' : { benefits: 'Available provider and demand-flexibility benefits compared separately', interested: 'Include participating-provider options and operating terms', no: 'Excluded from the requested proposal', unsure: 'Optional provider and flexibility options shown separately' }[state.vpp]) : 'Not applicable to a solar-only package');

      var businessName = leadBusiness && leadBusiness.value.trim() ? leadBusiness.value.trim() : 'Not supplied';
      var contactName = leadName && leadName.value.trim() ? leadName.value.trim() : 'Not supplied';
      var customerEmail = leadEmail && leadEmail.value.trim() ? leadEmail.value.trim() : 'Not supplied';
      var customerPhone = leadPhone && leadPhone.value.trim() ? leadPhone.value.trim() : 'Not supplied';
      var customerAddress = leadAddress && leadAddress.value.trim() ? leadAddress.value.trim() : 'Not supplied';
      var solarLine = isBatteryOnly ? labels.existingSolar[state.existingSolar] + ' system to be assessed' : selected.panels + ' × Risen 475 W (' + solarKw.toFixed(2) + ' kW)';
      var packageTitle = selected.name + (isBatteryOnly ? ' Storage' : (isSolarOnly ? ' Solar' : (isComparison ? ' Options' : '')));
      output('package-status', 'Recommendation updated: ' + packageTitle + ', ' + solarValue + ' solar, ' + (isSolarOnly ? 'no battery' : batteryKwh.toFixed(2) + ' kWh battery') + ' and ' + inverterValue + '.');
      var subject = 'Small business energy assessment — ' + packageTitle;
      var body = [
        'I would like a site-specific assessment for the ' + packageTitle + ' indicative package.',
        '',
        'Business: ' + businessName,
        'Contact: ' + contactName,
        'Email: ' + customerEmail,
        'Phone: ' + customerPhone,
        'Site address: ' + customerAddress,
        'Postcode: ' + postcodeValue,
        'Business type: ' + labels.business[state.business],
        'Site control: ' + labels.tenure[state.tenure],
        'Connection arrangement: ' + labels.connection[state.connection],
        'Monthly electricity spend: ' + labels.spend[state.spend],
        'Demand charge shown: ' + labels.demand[state.demand],
        'Operating profile: ' + labels.hours[state.hours],
        'System pathway: ' + systemLabel,
        'Existing solar: ' + labels.existingSolar[state.existingSolar],
        'Electricity supply selected: ' + labels.supply[state.supply],
        'Package supply assumption: ' + supplyAssumption,
        'Major loads: ' + listLabels(state.loads, labels.loads),
        'Primary goal: ' + labels.goal[state.goal],
        'Backup requirement: ' + labels.backup[state.backup],
        'Installation area: ' + labels.space[state.space],
        'Future plans: ' + listLabels(state.future, labels.future),
        'Commercial model: ' + labels.model[state.model],
        'VPP / flexibility preference: ' + labels.vpp[state.vpp],
        'Project timing: ' + labels.timing[state.timing],
        'Energy data available: ' + listLabels(state.data, labels.data),
        '',
        'Indicative solar: ' + solarLine,
        'Indicative battery: ' + (isSolarOnly ? 'Not included in this pathway' : selected.modules + ' × 5.12 kWh Dyness STACK100 Pro modules across ' + selected.clusters + ' ' + clusterWord + ' (' + batteryKwh.toFixed(2) + ' kWh nominal)'),
        'Indicative inverter: ' + inverterValue + ' Solis commercial pathway',
        'Site qualification: ' + siteFit,
        '',
        'Please confirm final sizing, grid connection, installed price and the separate STC, PRC and VPP / flexibility amounts.'
      ].join('\n');
      var answerSummary = [
        labels.business[state.business], labels.tenure[state.tenure], labels.connection[state.connection], labels.spend[state.spend] + ' monthly spend', 'Demand charge: ' + labels.demand[state.demand], labels.hours[state.hours], systemLabel,
        'Existing solar: ' + labels.existingSolar[state.existingSolar], labels.supply[state.supply], 'Loads: ' + listLabels(state.loads, labels.loads),
        labels.goal[state.goal], labels.backup[state.backup], labels.space[state.space], 'Future: ' + listLabels(state.future, labels.future),
        labels.model[state.model], 'VPP: ' + labels.vpp[state.vpp], labels.timing[state.timing], 'Data: ' + listLabels(state.data, labels.data)
      ].join(' | ');

      if (packageBodyField) packageBodyField.value = body;
      if (packageField) packageField.value = packageTitle + ' — ' + solarValue + ' solar; ' + (isSolarOnly ? 'no battery' : batteryKwh.toFixed(2) + ' kWh battery') + '; ' + inverterValue;
      if (answersField) answersField.value = answerSummary;
      var emailLink = root.querySelector('[data-package-email]');
      if (emailLink) emailLink.href = 'mailto:' + root.dataset.contactEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function bindSingle(buttons, stateKey, datasetKey) {
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          state[stateKey] = button.dataset[datasetKey];
          setPressed(buttons, button);
          render();
        });
      });
    }

    [groups.business, groups.tenure, groups.connection, groups.spend, groups.demand, groups.hours, groups.type, groups.existingSolar, groups.supply, groups.goal, groups.backup, groups.space, groups.model, groups.vpp, groups.timing].forEach(setupRovingGroup);

    bindSingle(groups.business, 'business', 'business');
    bindSingle(groups.tenure, 'tenure', 'tenure');
    bindSingle(groups.connection, 'connection', 'connection');
    bindSingle(groups.spend, 'spend', 'spend');
    bindSingle(groups.demand, 'demand', 'demand');
    bindSingle(groups.hours, 'hours', 'hours');
    bindSingle(groups.supply, 'supply', 'supply');
    bindSingle(groups.goal, 'goal', 'goal');
    bindSingle(groups.backup, 'backup', 'backup');
    bindSingle(groups.space, 'space', 'space');
    bindSingle(groups.model, 'model', 'model');
    bindSingle(groups.vpp, 'vpp', 'vpp');
    bindSingle(groups.timing, 'timing', 'timing');

    groups.type.forEach(function (button) {
      button.addEventListener('click', function () {
        state.type = button.dataset.systemType;
        setPressed(groups.type, button);
        if (state.type === 'battery-only' && state.existingSolar === 'none') {
          state.existingSolar = 'unsure';
          setPressed(groups.existingSolar, groups.existingSolar.filter(function (item) { return item.dataset.existingSolar === 'unsure'; })[0]);
        }
        render();
      });
    });

    groups.existingSolar.forEach(function (button) {
      button.addEventListener('click', function () {
        state.existingSolar = button.dataset.existingSolar;
        setPressed(groups.existingSolar, button);
        if (state.existingSolar === 'none' && state.type === 'battery-only') {
          state.type = 'solar-battery';
          setPressed(groups.type, groups.type.filter(function (item) { return item.dataset.systemType === 'solar-battery'; })[0]);
        }
        render();
      });
    });

    groups.loads.forEach(function (button) { button.addEventListener('click', function () { toggleMulti(button, state.loads, button.dataset.load); render(); }); });
    groups.future.forEach(function (button) { button.addEventListener('click', function () { toggleMulti(button, state.future, button.dataset.future); render(); }); });
    groups.data.forEach(function (button) { button.addEventListener('click', function () { toggleMulti(button, state.data, button.dataset.data); render(); }); });
    if (postcode) postcode.addEventListener('input', render);
    [leadBusiness, leadName, leadEmail, leadPhone, leadAddress].forEach(function (input) { if (input) input.addEventListener('input', render); });

    if (leadForm) {
      leadForm.addEventListener('submit', function (event) {
        var checks = [
          { input: leadBusiness, message: 'Please enter the business name.' },
          { input: leadName, message: 'Please enter the contact name.' },
          { input: leadEmail, message: 'Please enter a valid email address.' },
          { input: leadPhone, message: 'Please enter a phone number.' }
        ];
        [leadBusiness, leadName, leadEmail, leadPhone, leadConsent].forEach(function (input) {
          if (!input) return;
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
        });
        if (leadError) { leadError.hidden = true; leadError.textContent = ''; }
        function showError(input, message) {
          event.preventDefault();
          if (leadError) { leadError.textContent = message; leadError.hidden = false; }
          if (input) {
            input.setAttribute('aria-invalid', 'true');
            if (leadError && leadError.id) input.setAttribute('aria-describedby', leadError.id);
            input.focus();
          }
        }
        for (var index = 0; index < checks.length; index += 1) {
          if (!checks[index].input || !checks[index].input.value.trim() || !checks[index].input.checkValidity()) {
            showError(checks[index].input, checks[index].message);
            return;
          }
        }
        if (!leadConsent || !leadConsent.checked) {
          showError(leadConsent, 'Please confirm that Moebotics Energy may contact you about this assessment.');
          return;
        }
        render();
      });
    }

    [leadBusiness, leadName, leadEmail, leadPhone, leadConsent].forEach(function (input) {
      if (!input) return;
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', function () {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      });
    });
    var returnedFeedback = root.querySelector('.sbs-form-message--success, .sbs-form-message--error:not([hidden])');
    if (returnedFeedback) window.setTimeout(function () { returnedFeedback.focus(); }, 50);

    render();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-small-business-selector]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
